import { UnityRecorder } from '@sloyd/3d';
import { useParams } from 'react-router-dom';
import { useMount } from 'react-use';
import { Wrapper } from './PageRecorder.style';

export type PageRecorderProps = {};

export function PageRecorder(_props: PageRecorderProps) {
  const { generatorIndex } = useParams();

  useMount(() => {});

  return (
    <Wrapper className='PageRecorder-wrapper' data-testid='PageRecorder-wrapper'>
      <UnityRecorder generatorIndex={generatorIndex} />
    </Wrapper>
  );
}

export default PageRecorder;
